import React from 'react';
import TopNavBar from '../../components/TopNavBar/TopNavBar';
import styles from './RockCycleCanvas.module.css';

const RockCycleCanvas: React.FC = () => {
  return (
    <div className={styles.page}>
      <TopNavBar />
      <main className={styles.content}>
        <header className={styles.header}>
          <p className={styles.kicker}>Diagram Canvas</p>
          <h1>Rock Cycle (and beyond)</h1>
          <p>
            This page is a home for the diagramming canvas you mentioned. Plug in your existing
            canvas or flow tool below; we can reuse it for any process diagrams, not just the rock
            cycle.
          </p>
        </header>

        <section className={styles.viewer}>
          <div className={styles.instructions}>
            <h2>How to embed your canvas</h2>
            <ol>
              <li>If it is a standalone HTML page, set the iframe src below.</li>
              <li>If it is a React component, import and render it inside the viewport div.</li>
              <li>Keep the viewport roughly 16:9; adjust the min-height in the CSS if you prefer.</li>
            </ol>
          </div>

          <div className={styles.viewport}>
            <div className={styles.placeholder}>
              <p>
                Drop your canvas here. Edit <code>RockCycleCanvas.tsx</code> to load it.
              </p>
              <p>
                For quick wiring, replace this div with an <code>iframe</code> pointing at your
                existing rock-cycle page.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default RockCycleCanvas;
